// extracted by mini-css-extract-plugin
module.exports = {"confirm-buttons":"modals_confirm-buttons__cBFJc","confirm-message":"modals_confirm-message__v5QR0"};